import { t } from "./i18n";

export interface ProductWatchControlView {
  key: string;
  title: string;
  state: "none" | "active" | "paused";
}

function escape(value: string): string {
  return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}

function label(view: ProductWatchControlView): string {
  if (view.state === "none") return `${t("watchPrice")}: ${view.title}`;
  return `${t("watchEditAria", { title: view.title })} — ${t(view.state === "active" ? "priceTracked" : "watchPaused")}`;
}

/** Opens settings, not a toggle: opening alone never enables notifications. */
export function productWatchControlMarkup(view: ProductWatchControlView): string {
  const accessibleLabel = escape(label(view));
  return `<button type="button" class="card-price-watch${view.state === "active" ? " is-active" : view.state === "paused" ? " is-paused" : ""}"
    data-price-watch-product="${escape(view.key)}" data-watch-state="${view.state}"
    aria-label="${accessibleLabel}" title="${accessibleLabel}"
    aria-haspopup="dialog" aria-controls="price-watch-editor-dialog">
    <span class="card-watch-disc" aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <path d="M18 9.5a6 6 0 0 0-12 0c0 6-2.5 6-2.5 7.5h17C20.5 15.5 18 15.5 18 9.5Z" />
        <path d="M9.5 20h5" />
        <path class="card-watch-pause" d="m4 3 16 18" />
      </svg>
    </span>
  </button>`;
}

/** Preserve the button, keyboard focus and feed position on API state changes. */
export function updateProductWatchControl(button: HTMLButtonElement, view: ProductWatchControlView): void {
  button.classList.toggle("is-active", view.state === "active");
  button.classList.toggle("is-paused", view.state === "paused");
  button.dataset.watchState = view.state;
  const accessibleLabel = label(view);
  button.setAttribute("aria-label", accessibleLabel);
  button.title = accessibleLabel;
}
